/**
 * Admin tenant paths, in one place.
 *
 * Admin routes were hardcoded string literals in `AdminRoutes` and `AdminSidebar`; a third consumer
 * (the tenants grid, navigating into a row) is what makes that worth centralising.
 */

export const TENANTS_PATH = "/tenants";

export function tenantDetailPath(tenantId: number): string {
  return `${TENANTS_PATH}/${tenantId}`;
}
